import { VistaprintAuth } from '@vp/auth-react';
import { Link, Button, Icon } from '@vp/swan';
import React from 'react';

const SignInComponent = () => {
  const auth = new VistaprintAuth.WebAuth();
  const onButtonClick = () => {
    auth.signIn();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Link,
    {
      withIcon: true,
      render: ({ children, ...rest }) => /* @__PURE__ */ React.createElement(Button, { skin: "link", ...rest }, children),
      onClick: onButtonClick,
      compactMode: true
    },
    "Sign In ",
    /* @__PURE__ */ React.createElement(Icon, { iconType: "arrowRight", size: "standard", skin: "standard" })
  ));
};

export { SignInComponent as default };
//# sourceMappingURL=src-components-MessageComponent-SignInComponent.js.map
